import crypto from 'crypto'

declare global {
  interface Window {
    __csp_violations: Array<SecurityPolicyViolationEvent>
  }
}

/**
 * `captureCSPViolations` listens for `securitypolicyviolation`
 * events and stores them in global variable `__csp_violations`.
 */
export const captureCSPViolations = () => {
  window.__csp_violations = window.__csp_violations || []

  document.addEventListener('securitypolicyviolation', (event) => {
    window.__csp_violations.push(event)
  })
}

/**
 * `cspHashOf` computes SHA256 hash that can be
 * used for Content-Security-Policy header.
 * Based on https://github.com/vercel/next.js/blob/canary/examples/with-strict-csp/pages/_document.js
 */
export const cspHashOf = (text: string) => {
  const hash = crypto.createHash('sha256')
  hash.update(text)
  return `'sha256-${hash.digest('base64')}'`
}
